import React from 'react';
import './index.css';

export const Label12 = ({ bold=false, disabled=false, children }) => {
    const textStyle =  { fontWeight: (bold) ? '600': 'normal' };
    const cssClass = disabled ? "label12 labelDisabled" : "label12";
    return <label className={cssClass} style={textStyle}>{children}</label>;
};